import { useState } from "react";
import api from "../../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { fmtDateTimeWIB, fmtIDR } from "../util";

function DocRow({ x }) {
    return (
        <li className={`py-2 border-b border-mist/60 text-xs ${x.included ? "" : "opacity-60"}`} data-testid={`jdetail-row-${x.ref}`}>
            <div className="flex justify-between gap-2"><b className="text-ink">{x.ref}</b><span className="tabular-nums font-medium">{fmtIDR(x.product_idr)}</span></div>
            <div className="text-neutral-500">{x.customer_name || "—"} · {x.transaction_date ? fmtDateTimeWIB(x.transaction_date) : "tanpa waktu"} · {x.internal_status || x.kind}</div>
            <div className="flex flex-wrap gap-x-3 text-neutral-500">
                <span>Ongkir {x.shipping_idr != null ? fmtIDR(x.shipping_idr) : "—"}</span><span>is_po: {String(x.is_po)}</span>
                <span>{x.counts_as_order ? "dihitung 1 order" : "bukan order"}</span>
                {x.unknown_lines > 0 && <span className="text-amber-700">{x.unknown_lines} SKU belum terpetakan</span>}
            </div>
            <div className={x.included ? "text-emerald-700" : "text-rose-700"}>{x.included ? "Termasuk" : "Tidak termasuk"} — {x.reason}</div>
            {x.lines?.length > 0 && <ul className="mt-1 pl-2 border-l border-mist">{x.lines.map((l, i) => (
                <li key={i} className="text-neutral-500">{l.sku || "—"} · {l.name} · {l.qty}× · {fmtIDR(l.amount_idr)}{l.brand === "UNKNOWN" ? " · belum terpetakan" : ""}</li>))}</ul>}
        </li>
    );
}

export default function JubelioDetail({ cid, k, label }) {
    const [data, setData] = useState(null);
    const [err, setErr] = useState(null);
    const [open, setOpen] = useState(false);
    const load = async () => {
        setOpen(true); setData(null); setErr(null);
        try { setData((await api.get(`/reporting/v2/sales-closing/${cid}/jubelio-detail`, { params: { channel: k } })).data); }
        catch (e) { setErr(e?.response?.data?.detail || "Gagal memuat detail"); }
    };
    return (
        <>
            <button type="button" className="text-[11px] underline text-neutral-600" onClick={load} data-testid={`jdetail-btn-${k}`}>Lihat Detail</button>
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="jdetail-dialog">
                    <DialogHeader><DialogTitle>Detail Jubelio · {label}</DialogTitle></DialogHeader>
                    {err && <p className="text-sm text-rose-700" data-testid="jdetail-error">{err}</p>}
                    {!data && !err && <p className="text-sm text-neutral-400">Memuat…</p>}
                    {data && (
                        <div className="space-y-2">
                            <p className="text-[11px] text-neutral-500">Periode: {data.period_label} · data Jubelio {fmtDateTimeWIB(data.fetched_at)}</p>
                            <div className={`text-xs rounded-sm border px-3 py-2 ${data.reconciled ? "border-emerald-300 bg-emerald-50" : "border-rose-300 bg-rose-50"}`} data-testid="jdetail-total">
                                Total detail: <b>{fmtIDR(data.detail_sales_idr)} · {data.detail_orders} order</b> — Jubelio di perbandingan: {fmtIDR(data.jubelio_sales_idr)} · {data.jubelio_orders} order
                                {data.message && <div className="text-rose-700 mt-1">{data.message}</div>}
                            </div>
                            {data.rows.length === 0 ? <p className="text-sm text-neutral-400">Tidak ada transaksi Jubelio di channel ini.</p> : <ul>{data.rows.map((x) => <DocRow key={x.ref + x.kind} x={x} />)}</ul>}
                        </div>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
}
